import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Input, Label, Row, UncontrolledAlert, Spinner } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import BreadCrumb from "../../../../Components/Common/BreadCrumb";
import * as Yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import { Get_cities, Get_Countries, POST_PINCODE } from "../../../../helpers/url_helper";
import Toast from "../../../../Components/Common/Toast";
import { APIClient } from "../../../../helpers/api_helper";
import { createLeadRequest, editLeadRequest } from "../../../../store/leadManagement/actions";
import { useDispatch, useSelector } from "react-redux";
import { useMasterApi } from "../../../../Components/Hooks/UserHooks";
import { CommonFormInput } from "../../../../Components/Common/CommonFormInput";
import { CommonLabel } from "../../../../Components/Common/CommonLabel";
import { CommonSelectInput } from "../../../../Components/Common/CommonSelectInput";
import { CommonPhoneInput } from "../../../../Components/Common/CommonPhoneInput";
import { fetchEmployeesRequest } from "../../../../store/FetchEmployees/action";
import { fetchLeadStatusRequest } from "../../../../store/FetchLeadStatus/action";
import Loader from "../../../../Components/Common/Loader";
const api = new APIClient();



const LeadForm = ({ isEditMode = false, initialData = null, pathName }) => {
    const emailRules = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { loading, error, lead } = useSelector(state => state.LeadReducer);
    const { statusOptions } = useSelector(state => state.leadStatusReducer);
    const { employees } = useSelector(state => state.fetchEmployeeReducer);


    const [countries, setCountries] = useState([]);
    const [countryCode, setCountryCode] = useState("+91");
    // city state
    const [searchResults, setSearchResults] = useState(null);
    const [getCity, setGetCity] = useState([]);
    const [selectedCity, setSelectedCity] = useState("");
    const [customCity, setCustomCity] = useState("");
    const [mobileNumbers, setMobileNumbers] = useState("");

   
    // Back in Lead List
    const handleBack = () => {
        navigate(-1);
    };


    useEffect(() => {
        dispatch(fetchEmployeesRequest());
    }, [dispatch]);

    useEffect(() => {
        dispatch(fetchLeadStatusRequest());
    }, [dispatch]);



    useEffect(() => {
        fetchCountries();
    }, []);

    //fetch countries from api
    const fetchCountries = async () => {
        try {
            const response = await api.create(`${Get_Countries}`);
            if (response?.success && response?.data && response?.data.data) {
                const filteredCountries = response?.data.data.filter(
                    (country) => country !== ""
                );
                setCountries(filteredCountries);
            }
        } catch (error) {
            Toast("Failed to fetch countries list", "error");
        }
    };



    const formik = useFormik({
        enableReinitialize: pathName === "editForm" ? true : false,
        initialValues: {
            firtName: pathName === "editForm" ? initialData?.firstName || '' : "",
            lastName: pathName === "editForm" ? initialData?.lastName || '' : "",
            mobileNumber: initialData?.phone || "",
            // alternateNumber: pathName === "editForm" ? initialData?.firstName || '' : "",
            leadstatus: pathName === "editForm" ? initialData?.status || '' : "",
            assigned: pathName === "editForm" ? initialData?.assignedTo?.[0]?._id || '' : "",
            companyName: pathName === "editForm" ? initialData?.companyName || '' : "",
            addressTwo: pathName === "editForm" ? initialData?.address2 || '' : "",
            email: pathName === "editForm" ? initialData?.email || '' : "",
            addressone: pathName === "editForm" ? initialData?.address1 || '' : "",
            city: pathName === "editForm" ? initialData?.city || '' : "",
            state: pathName === "editForm" ? initialData?.state || '' : "",
            postalcode: pathName === "editForm" ? initialData?.pincode || '' : "",
            country: pathName === "editForm" ? initialData?.country || '' : "",
            countryCode: pathName === "editForm" ? countryCode : "",
            source: pathName === "editForm" ? initialData?.source || '' : "",
            dealAmount: pathName === "editForm" ? initialData?.dealAmount || '' : "",
            description: pathName === "editForm" ? initialData?.description || '' : "",
            terms: pathName === "editForm" ? initialData?.mapCallLogs : false,
        },
        validationSchema: Yup.object({
            firtName: Yup.string()
                .required("First Name is required")
                .max(250, "First Name must not be more than 150 characters"),
            // lastName: Yup.string()
            //     .required("Last Name is required")
            //     .max(250, "Last Name must not be more than 150 characters"),
            mobileNumber: Yup.string()
                .required("Mobile number is required")
                .test(
                    "is-valid-mobile",
                    "Enter a Mobile number",
                    (value) => value && value.length > 3
                ),
            // alternateNumber: Yup.string()
            //     .required("Mobile number is required")
            //     .test(
            //         "is-valid-mobile",
            //         "Enter a Mobile number",
            //         (value) => value && value.length > 3
            //     ),
            // leadstatus: Yup.string().required("Status is required"),
            assigned: Yup.string().required("Assigned is required"),
            // companyName: Yup.string()
            //     .required("Company Name is required"),
            email: Yup.string()
                .email("Please enter a valid email address")
                .matches(emailRules, { message: "  Invalid email" }),
            // .required("Email Address is required"),
            // terms: Yup.boolean().isTrue(
            //     "You must accept the terms and conditions to proceed. Please ensure the 'Map available Call log' option is selected."
            // ),
            // addressone: Yup.string().required("Address Name is required"),
            // city: Yup.string().required("City Name is required"),
            // state: Yup.string().required("State Name is required"),
            postalcode: Yup.string()
                .min(4, "Postal code should be at least 4 digits long")
                .max(12, "Postal code must have a maximum of 12 digits")
                .matches(/^(?=.*\d)[A-Za-z0-9- ]{4,12}$/,"Postal code must be characters and include a number.")
            // .required("Postal code is required"),
            // country: Yup.string().required("Country Name is required"),
            // source: Yup.string().required("Please enter Source  is required"),
            // dealAmount: Yup.string().required("Please enter Amount is required"),

        }),
        onSubmit: async (value) => {
            let status = value.leadstatus.length > 0 ? value.leadstatus : undefined
            let email = value.email.length > 0 ? value.email : undefined

            const leadeditData = {
                leadIds: [initialData?._id],
                firstName: value.firtName,
                lastName: value.lastName,
                // email: value.email,
                phone: mobileNumbers,
                countryCode: countryCode,
                alternatePhoneNumber: '',
                ...(status && { status }),
                ...(email && { email }),
                // status: value.leadstatus,
                assignedTo: value.assigned.includes(',')
                    ? value.assigned.split(',')
                    : [value.assigned],
                companyName: value.companyName,
                address1: value.addressone,
                address2: value.addressTwo,
                source: value.source,
                city: value.city,
                country: value.country,
                state: value.state,
                pincode: value.postalcode,
                dealAmount: value.dealAmount,
                description: value?.description,
                mapCallLogs: value.terms
            };

            // const leadData = {
            //     firstName: value.firtName,
            //     lastName: value.lastName,
            //     email: value.email,
            //     phone: mobileNumbers,
            //     countryCode: countryCode,
            //     alternatePhoneNumber: '',
            //     status: value.leadstatus,
            //     assignedTo: [value.assigned],
            //     companyName: value.companyName,
            //     Address1: value.addressone,
            //     Address2: value.addressTwo,
            //     source: value.source,
            //     city: value.city,
            //     country: value.country,
            //     state: value.state,
            //     pincode: value.postalcode,
            //     dealAmount: value.dealAmount,
            //     description: value?.description,
            //     mapCallLogs: value.terms
            // };

            try {
                if (pathName === "editForm") {
                    console.log('pathName', pathName);
                    
                    dispatch(editLeadRequest({ ...leadeditData, id: initialData._id }, navigate(-1)));
                } else {
                    dispatch(createLeadRequest(leadeditData, navigate(-1)));
                }
            } catch (error) {
                toast.error(error.response?.data?.message, { autoClose: 1000 });
            }
        },
    });
     const {
        handleSubmit,
        errors,
        touched,
        setFieldValue,
        getFieldProps,
        setFieldError,
        setFieldTouched,
        resetForm,
    } = formik;


    useEffect(() => {
        if (initialData && pathName === "editForm") {
            setCountryCode(initialData.countryCode || "+91");
            setMobileNumbers(initialData.phone || "");

            // Update all form fields including phone
            setFieldValue("mobileNumber", initialData.phone || "");
            setFieldValue("countryCode", initialData.countryCode || "+91");
            setFieldValue("firtName", initialData.firstName || "");
            setFieldValue("lastName", initialData.lastName || "");
            setFieldValue("email", initialData.email || "");
            // ... set other fields
        }
    }, [initialData, pathName, setFieldValue]);



    const handleOnChange = (value, data) => {
        let cleanedNumber = value;
        if (!value.startsWith("+")) {
            cleanedNumber = `+${value}`;
        }
        const dialCode = data.dialCode;
        const dialCountryCode = `+${data.dialCode}`;
        const numberWithoutDialCode = cleanedNumber
            .replace(`+${dialCode}`, "")
            .trim();
        setCountryCode(dialCountryCode);
        setMobileNumbers(numberWithoutDialCode);

        // Update Formik values
        setFieldValue("countryCode", dialCountryCode);
        setFieldValue("mobileNumber", numberWithoutDialCode);

        // Optionally clear errors on valid input
        if (errors.mobileNumber) {
            setFieldError("mobileNumber", "");
        }
    };


    const handleCountryChange = (event) => {
        const country = event.target.value;
        setFieldValue("country", country);
        setSelectedCity(null);
        setCustomCity("");
        setFieldValue("city", "");
        setSearchResults([]);
        fetchCitiesByCountry(country);
    };


    //fetch cities based on country
    const fetchCitiesByCountry = async (country) => {
        try {
            const data = { _id: country };
            const response = await api.create(`${Get_cities}`, data);
            if (response.success === true) {
                setGetCity(response.data.data);
            }
        } catch (error) {
            console.log(error, "error");
        }
    };


    const getPostalCode = async (city) => {
        try {
            const data = { cityName: city };
            const response = await api.create(`${POST_PINCODE}`, data);
            if (response.success === true) {
                // setPostalCode(response.data);
            }
        } catch (error) {
            console.log(error, "error");
        }
    };


    const handleStatusChange = (event) => {
        const status = event.target.value;
        setFieldValue("leadstatus", status);
    }


    const handleAssignedChange = (e) => {
        const selectedValue = e.target.value;
        if (selectedValue === "all") {
            // Join all employee IDs into a comma-separated string
            const allEmployeeIds = employees.map(employee => employee._id).join(',');
            setFieldValue("assigned", allEmployeeIds);
        } else {
            // Set the single ID directly as string
            setFieldValue("assigned", selectedValue);
        }
    };



    //search function
    const handleSearch = (searchTerm) => {
        if (!searchTerm.trim()) {
            setSearchResults(null);
            return;
        }

        // Filter cities based on the search term (case insensitive)
        const filteredCities = getCity.filter(city =>
            city.toLowerCase().includes(searchTerm.toLowerCase())
        );

        // Ensure "Other" is always available as an option in the search results
        if (!filteredCities.includes("Other")) {
            filteredCities.push("Other");
        }

        setSearchResults(filteredCities);
    };

    const handleCityClick = (value) => {
        getPostalCode(value);
    };

    const resetInputHistory = () => {
      const emptyValues = {
        firtName: "",
        lastName: "",
        mobileNumber: "",
        leadstatus: "",
        assigned: "",
        companyName: "",
        addressTwo: "",
        email: "",
        addressone: "",
        city: "",
        state: "",
        postalcode: "",
        country: "",
        countryCode: "+91",
        source: "",
        dealAmount: "",
        description: "",
        terms: false,
      };

      resetForm({ values: emptyValues }); // ✅ now works

      // extra states reset
      setMobileNumbers("");
      setSelectedCity("");
      setCustomCity("");
      setCountryCode("+91");
      setSearchResults(null);
      setGetCity([]);
    };


    return (
        <>
            <ToastContainer />
            {loading && (
                <div className="loader-overlay">
                    <Loader />
                </div>
            )}
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <BreadCrumb title={pathName === 'editForm' ? "Lead Update" : "Add Lead"} pageTitle="Add / Import Lead" />
                    </div>

                    <div className="row">
                        <Card>
                            <div className="mt-4 mb-4 border-bottom">

                                <button
                                    onClick={handleBack}
                                    className="btn btn-sm border border-rounded shadow backbtn-main mb-4"
                                >
                                    <i className="ri-arrow-left-line me-1"></i> Back
                                </button>
                            </div>
                            <Form
                                onSubmit={handleSubmit}
                                className="needs-validation custom-register-form-sec"
                            >

                                <Row>
                                    <Row>
                                        {/* First Name*/}
                                        <Col sm={3}>
                                            <CommonLabel htmlFor="firtName" isRequired>
                                                First Name
                                            </CommonLabel>
                                            <CommonFormInput
                                                onInput={(e) => {
                                                    e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, '');
                                                    setFieldValue('firtName', e.target.value);
                                                }}
                                                name="firtName"
                                                type="text"
                                                placeholder="Enter First Name"
                                                getFieldProps={getFieldProps}
                                                touched={touched}
                                                errors={errors}
                                            />
                                        </Col>
                                        {/* Last Name */}
                                        <Col sm={3}>
                                            <CommonLabel htmlFor="lastName">
                                                Last Name
                                            </CommonLabel>
                                            <CommonFormInput
                                                onInput={(e) => {
                                                    e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, '');
                                                    setFieldValue('lastName', e.target.value);
                                                }}
                                                name="lastName"
                                                type="text"
                                                placeholder="Enter Last Name"
                                                getFieldProps={getFieldProps}
                                                touched={touched}
                                                errors={errors}
                                            />
                                        </Col>
                                        {/* Phone */}
                                        <Col sm={3}>
                                            <CommonLabel htmlFor="phoneNumber" isRequired>
                                                Phone Number
                                            </CommonLabel>
                                            <div className="sn-country-code-flag-de">
                                                <CommonPhoneInput
                                                    country="in"
                                                    value={pathName === "editForm" ? `${countryCode}${mobileNumbers}` : ""}
                                                    onChange={handleOnChange}
                                                    onBlur={() => setFieldTouched("mobileNumber", true)}
                                                    touched={touched.mobileNumber}
                                                    errors={errors.mobileNumber}
                                                />
                                            </div>

                                        </Col>
                                        {/* Email */}
                                        <Col sm={3}>
                                            <CommonLabel htmlFor="email">
                                                Email
                                            </CommonLabel>
                                            <CommonFormInput
                                                name="email"
                                                type="email"
                                                placeholder="Enter email address"
                                                getFieldProps={getFieldProps}
                                                touched={touched}
                                                errors={errors}
                                            />
                                        </Col>
                                    </Row>

                                    <Row className="mt-3">
                                        {/* alternative Number Phone */}
                                        {/* <Col sm={3}>
                                            <CommonLabel htmlFor="alternateNumber">
                                                Alternate number
                                            </CommonLabel>
                                            <CommonFormInput
                                                name="alternateNumber"
                                                type="text"
                                                placeholder="Enter Alternate number"
                                                getFieldProps={getFieldProps}
                                                touched={touched}
                                                errors={errors}
                                            />
                                        </Col> */}
                                        {/* source */}
                                        <Col sm={3}>
                                            <CommonLabel htmlFor="source">
                                                Source
                                            </CommonLabel>
                                            <CommonFormInput
                                                onInput={(e) => {
                                                    e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, '');
                                                    setFieldValue('source', e.target.value);
                                                }}
                                                name="source"
                                                type="text"
                                                placeholder="Enter Source...."
                                                getFieldProps={getFieldProps}
                                                touched={touched}
                                                errors={errors}
                                            />
                                        </Col>
                                        {/* Status */}
                                        <Col sm={3}>
                                            <CommonLabel htmlFor="leadstatus">
                                                Select Status
                                            </CommonLabel>

                                            <CommonSelectInput
                                                name="leadstatus"
                                                label="Select Status"
                                                isRequired={true}
                                                value={getFieldProps("leadstatus").value}
                                                onChange={handleStatusChange}
                                                onBlur={getFieldProps("leadstatus").onBlur}
                                                options={statusOptions}
                                                touched={touched.leadstatus}
                                                errors={errors.leadstatus}
                                                tooltipId="my-tooltip-5"
                                            />


                                        </Col>

                                        {/* Assigned to */}
                                        <Col sm={3}>
                                            <CommonLabel htmlFor="assigned" isRequired>
                                                Assigned
                                            </CommonLabel>

                                            {/* Assigned Select */}
                                            <CommonSelectInput
                                                name="assigned"
                                                label="Assigned"
                                                isRequired={true}
                                                value={getFieldProps("assigned").value || ""}
                                                onChange={handleAssignedChange}
                                                onBlur={getFieldProps("assigned").onBlur}
                                                options={[
                                                    { value: "all", label: "All Employees" },
                                                    ...employees.map((assigned) => ({
                                                        value: assigned?._id,
                                                        label: assigned?.fullName,
                                                    })),
                                                ]}
                                                touched={touched.assigned}
                                                errors={errors.assigned}
                                                tooltipId="my-tooltip-5"
                                            />

                                        </Col>

                                        {/* Company Name */}
                                        <Col sm={3}>
                                            <CommonLabel htmlFor="companyName">
                                                Company Name
                                            </CommonLabel>
                                            <CommonFormInput
                                                onInput={(e) => {
                                                    e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, '');
                                                    setFieldValue('companyName', e.target.value);
                                                }}
                                                name="companyName"
                                                type="text"
                                                placeholder="Enter Company Name"
                                                getFieldProps={getFieldProps}
                                                touched={touched}
                                                errors={errors}
                                            />
                                        </Col>
                                    </Row>

                                    <Row className="mt-3">
                                        {/* Address one Input */}
                                        <Col sm={3}>
                                            <CommonLabel htmlFor="addressone">
                                                Address 1
                                            </CommonLabel>
                                            <CommonFormInput
                                                name="addressone"
                                                type="text"
                                                placeholder="Enter Address"
                                                getFieldProps={getFieldProps}
                                                touched={touched}
                                                errors={errors}
                                            />
                                        </Col>
                                        {/* Address Two Input */}
                                        <Col sm={3}>
                                            <CommonLabel htmlFor="addressTwo">
                                                Address 2
                                            </CommonLabel>
                                            <CommonFormInput
                                                name="addressTwo"
                                                type="text"
                                                placeholder="Enter Address"
                                                getFieldProps={getFieldProps}
                                                touched={touched}
                                                errors={errors}
                                            />
                                        </Col>


                                        {/* Country */}
                                        <Col sm={3}>
                                            <CommonLabel htmlFor="country">
                                                Select Country
                                            </CommonLabel>
                                            <CommonSelectInput
                                                name="country"
                                                label="Select Country"
                                                value={getFieldProps("country").value}
                                                onChange={handleCountryChange}
                                                onBlur={getFieldProps("country").onBlur}
                                                options={countries.map((country) => ({
                                                    value: country,
                                                    label: country,
                                                }))}
                                                touched={touched.country}
                                                errors={errors.country}
                                                tooltipId="my-tooltip-5"
                                            />
                                        </Col>



                                        {/* State */}
                                        <Col sm={3}>
                                            <CommonLabel htmlFor="state">
                                                State
                                            </CommonLabel>
                                            <CommonFormInput
                                                onInput={(e) => {
                                                    e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, '');
                                                    setFieldValue('state', e.target.value);
                                                }}
                                                name="state"
                                                type="text"
                                                placeholder="Enter State Name"
                                                getFieldProps={getFieldProps}
                                                touched={touched}
                                                errors={errors}
                                            />
                                        </Col>
                                    </Row>


                                    <Row className="mt-3">
                                        <Col sm={3}>
                                            <CommonLabel htmlFor="City">
                                                City
                                            </CommonLabel>

                                            <div className="position-relative">
                                                <Input
                                                    onInput={(e) => {
                                                        e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, '');
                                                        setFieldValue('city', e.target.value);
                                                    }}
                                                    type="text"
                                                    data-tooltip-id="my-tooltip-8"
                                                    className={`form-control ${touched.city && errors.city ? "is-invalid" : ""
                                                        }`}
                                                    name="city"
                                                    value={
                                                        selectedCity === "Other" ? customCity : getFieldProps("city").value
                                                    }
                                                    onChange={(e) => {
                                                        if (selectedCity === "Other") {
                                                            setCustomCity(e.target.value);
                                                        } else {
                                                            setFieldValue("city", e.target.value);
                                                            handleSearch(e.target.value);
                                                        }
                                                    }}
                                                    onBlur={getFieldProps("city").onBlur}
                                                    placeholder={
                                                        selectedCity === "Other" || !selectedCity ? "Search city..." : "Enter Other City..."
                                                    }
                                                />
                                                {searchResults && searchResults.length > 0 && (
                                                    <div
                                                        className="position-absolute w-100 bg-white border rounded mt-1"
                                                        style={{ zIndex: 1000, maxHeight: "200px", overflowY: "auto" }}
                                                    >
                                                        {searchResults.map((city, index) => (
                                                            <div
                                                                key={index}
                                                                className="p-2 cursor-pointer hover:bg-light"
                                                                onClick={() => {
                                                                    setSelectedCity(city);
                                                                    setFieldValue("city", city);
                                                                    if (city === "Other") {
                                                                        setCustomCity("");
                                                                    } else {
                                                                        handleCityClick(city);
                                                                    }
                                                                    setSearchResults(null);
                                                                }}
                                                            >
                                                                {city}
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                            {touched.city && errors.city && (
                                                <div className="invalid-feedback">{errors.city}</div>
                                            )}
                                        </Col>

                                        {/* Pincode */}
                                        <Col sm={3}>
                                            <CommonLabel htmlFor="postalcode">
                                                Postal-Code
                                            </CommonLabel>
                                            <CommonFormInput
                                                onInput={(e) => {
                                                    const v = e.target.value.replace(/[^A-Za-z0-9- ]/g, '').slice(0, 12);
                                                    e.target.value = v;
                                                    setFieldValue('postalcode', v);
                                                }}
                                                name="postalcode"
                                                type="text"
                                                placeholder="Enter Postal Code"
                                                getFieldProps={getFieldProps}
                                                touched={touched}
                                                errors={errors}
                                            />
                                        </Col>


                                        <Col sm={3}>
                                            <CommonLabel htmlFor="dealAmount">
                                                Deal Amount
                                            </CommonLabel>
                                            <CommonFormInput
                                                onInput={(e) => {
                                                    e.target.value = e.target.value.replace(/[^\d.]/g, '');  // Allows only digits and decimal point
                                                    setFieldValue('dealAmount', e.target.value);
                                                }}
                                                name="dealAmount"
                                                type="text"
                                                placeholder="Enter Deal Amount "
                                                getFieldProps={getFieldProps}
                                                touched={touched}
                                                errors={errors}
                                            />
                                        </Col>
                                    </Row>

                                    <Row className="mt-3">
                                        {/* Description  */}
                                        <Col sm={12}>
                                            <CommonLabel htmlFor="description">
                                                Description
                                            </CommonLabel>
                                            <CommonFormInput
                                                name="description"
                                                type="textarea"
                                                getFieldProps={getFieldProps}
                                                touched={touched}
                                                errors={errors}
                                            />
                                        </Col>
                                    </Row>



                                    {<Row className="mt-3">
                                        <Col sm={12}>
                                            <CommonFormInput
                                                name="terms"
                                                type="checkbox"
                                                getFieldProps={getFieldProps}
                                                touched={touched}
                                                errors={errors}
                                            />
                                            &nbsp;
                                            <CommonLabel>
                                                Map available Call log
                                            </CommonLabel>
                                        </Col>
                                    </Row>}


                                    <div className="mt-2">
                                        {touched.terms && errors.terms && (
                                            <>
                                                <UncontrolledAlert
                                                    color="danger"
                                                    className="mb-xl-0"
                                                    toggle={undefined}
                                                >
                                                    <strong>{errors.terms}</strong>
                                                </UncontrolledAlert>
                                            </>
                                        )}
                                    </div>


                                    {/* Submit Button */}
                                    <div className="col-lg-12 mb-4 mt-3">
                                        <div className="d-flex justify-content-center gap-4">
                                            <button
                                                onClick={resetInputHistory}
                                                type="button"
                                                id="exampleSelect"
                                                className="btn btn-outline-danger"
                                            >
                                                Reset
                                            </button>
                                            <Button d="add-btn" color="primary" className="btn btn-danger" type="submit">
                                                {pathName ? 'Update Lead' : 'Save'}
                                            </Button>
                                        </div>
                                    </div>
                                </Row>
                                {/* </div> */}
                            </Form>
                        </Card>
                    </div>
                </div>
            </div>
        </>
    );
}

export default LeadForm;